const toNumberOrNull = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

/** Word count × cost per unit, to the cent; null until both are entered. */
export const lineUnitCost = (wordCount, costPerUnit) => {
  const words = toNumberOrNull(wordCount);
  const cost = toNumberOrNull(costPerUnit);
  return words === null || cost === null ? null : Math.round(words * cost * 100) / 100;
};
